// removed by extract-text-webpack-plugin
module.exports = {"App":"_3v2noHK-r1riU4z7a5jATz"};


//////////////////
// WEBPACK FOOTER
// ./src/app.scss
// module id = 468
// module chunks = 0